import { FunctionComponent } from 'react';

import { SearchIndex } from '@kanda-libs/ks-frontend-services';

import Tab from './Tab';

interface TabsProps {
  index?: SearchIndex;
  tabs?: SearchIndex[];
  onTabClick: (idx: SearchIndex) => void;
}

const Tabs: FunctionComponent<TabsProps> = function ({
  index,
  tabs,
  onTabClick,
}) {
  if (!index || !tabs) return null;
  return (
    <div className="flex flex-row w-full border border-neutral-300 border-b-0 rounded-t-lg overflow-hidden">
      {tabs.map((tab: SearchIndex) => (
        <Tab index={index} tab={tab} onTabClick={onTabClick} />
      ))}
    </div>
  );
};

export default Tabs;
